/**
 * @generated SignedSource<<b2ceb744b58f553c530d88c3fbdce192>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RetryMessageInput = {
  messageId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type retryMessageMutation$variables = {
  input: RetryMessageInput;
};
export type retryMessageMutation$data = {
  readonly retryMessage: {
    readonly clientMutationId: string | null;
    readonly message: {
      readonly id: string;
      readonly deliveryStatus: string | null;
      readonly retryCount: number;
    };
  } | null;
};
export type retryMessageMutation = {
  variables: retryMessageMutation$variables;
  response: retryMessageMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RetryMessagePayload",
    "kind": "LinkedField",
    "name": "retryMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageActivity",
        "kind": "LinkedField",
        "name": "message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliveryStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "retryCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "retryMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "retryMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "af318bf04773ba7fa47ac888777e3897",
    "id": null,
    "metadata": {},
    "name": "retryMessageMutation",
    "operationKind": "mutation",
    "text": "mutation retryMessageMutation(\n  $input: RetryMessageInput!\n) {\n  retryMessage(input: $input) {\n    clientMutationId\n    message {\n      id\n      deliveryStatus\n      retryCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "839f0c01d9596ecc12c4106c2bba2789";

export default node;
